export default function Marquee({ items }) {
  const row = items.join("  ·  ");
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden py-8 border-y border-[#1A1A1A]/8 bg-[#F4F4F1]">
      <div className="animate-marquee flex whitespace-nowrap">
        {[0, 1].map((i) => (
          <span key={i} className="font-serif italic text-xl md:text-2xl text-[#4A4A4A] pr-32 pl-32">
            {row}&nbsp;&nbsp;·&nbsp;&nbsp;
          </span>
        ))}
      </div>
    </div>
  );
}
